import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";
import { api } from "./lib/api";
import { configureFormatting } from "./lib/format";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
});

function render() {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

// Currency, locale and time zone come from the tenant the console is pointed at,
// so one build serves every deployment. Public endpoint — no token needed, and
// a failure must never keep the console from booting.
api
  .get<{ app_name: string; currency: string; locale: string; time_zone: string }>("/brand")
  .then((brand) => {
    configureFormatting({ currency: brand.currency, locale: brand.locale, timeZone: brand.time_zone });
    document.title = `${brand.app_name} Console`;
  })
  .catch(() => {})
  .finally(render);
